import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {XummSdkJwt} from 'xumm-sdk'

const app = createApp(App)
app.config.globalProperties.$xapp = new XummSdkJwt(process.env.VUE_APP_XUMM_KEY)

app.use(store).use(router).mount('#app')
